<div class="header">
	<div class="country">{{ 'columns.country' | translate }}</div>
	<div>{{ 'columns.network' | translate }}</div>
</div>
@for (country of countries; track country; let index = $index; let last = $last) {
	<div [class.no-divider]="last && countriesNetworks.size <= MAX_VISIBLE_COUNTRIES" class="row">
		<b class="country">{{ country }}</b>
		<div class="networks">
			@for (network of getNetworks(country); track network) {
				<div [alarisTooltip]="network" [overflow]="true" class="network-item text-truncate">{{ network }}</div>
			}
			@if ((countriesNetworks.get(country)?.size ?? 0) > maxVisibleNetworks) {
				<button
					(click)="toggleNetworksVisibility(country)"
					data-testid="toggleNetworksVisibility"
					class="reset toggle toggle__network"
				>
					@let amount = (countriesNetworks.get(country)?.size ?? 0) - maxVisibleNetworks;
					<span>
						{{ amount }}
						{{ getNetworksPostfix(amount) }}
					</span>
					<alaris-icon [class.expanded]="expandedNetworks.get(country)" class="icon" name="icon-arrow-select">
					</alaris-icon>
				</button>
			}
		</div>
	</div>
}
@if (countriesNetworks.size > MAX_VISIBLE_COUNTRIES) {
	<button
		(click)="toggleCountriesVisibility()"
		class="reset toggle toggle__country"
		data-testid="toggleCountriesVisibility"
	>
		<span>
			{{
				'purchase.showMore'
					| translate
						: {
								amount: countriesNetworks.size - MAX_VISIBLE_COUNTRIES,
						  }
			}}
		</span>
		<alaris-icon [class.expanded]="expandedCountries" class="icon" name="icon-arrow-select"> </alaris-icon>
	</button>
}
